import {Component, Module} from 'app/decorators';
import _ from 'lodash';

import CropPicker from 'app/directives/crop.picker';

import tpl from './max.rates.table.html';


@Module({
    name: "app.directives.max.rates.component",
    modules: [
        CropPicker
    ]
})
@Component({
    selector: 'blnd-max-rates',
    bindings: {
        ngModel: '=',
        mode: '@?',
        errors: '=?',
    },
    template: tpl,
})
export default class C {
    constructor() {
        "ngInject";
        let self = this;

        self.mode = self.mode || 'view';
    }

    add () {
        this.ngModel.push({});
    }

    remove (item) {
        let index = this.ngModel.indexOf(item);
        this.ngModel.splice(index, 1);
    }

    onPress (event, isLast) {
        if (event.which === 9 && isLast) {
            this.add();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/components/max.rates.table.js